var map = {
	"./Roberto_Raddi.png": "5edb",
	"./Roberto_Raddi_profile.png": "0d7b",
	"./background-img.png": "cf09",
	"./cv.jpg": "413b",
	"./nasa-ads.png": "8ade",
	"./orcid.png": "bfc2",
	"./profile.jpg": "3a19",
	"./profile_small.png": "09dd",
	"./publons.png": "b139",
	"./research-1.jpg": "2d60",
	"./research-2.jpg": "0b55",
	"./scopus.png": "9771",
	"./style.css": "7d05"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";